import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import Button from 'components/button'

import styles from './customers-export.css'

const CustomersExport = ({ exportUrl }) => (
  <div styleName="customers-export">
    <div><a href={exportUrl}><Button text="Export customers" type="action" /></a></div>
  </div>
)

CustomersExport.propTypes = {
  exportUrl: PropTypes.string.isRequired,
}

export default CSSModules(CustomersExport, styles)



/** WEBPACK FOOTER **
 ** ./src/components/customers-export/customers-export.js
 **/